export const TableOfContentsStyle = {
    container: {
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    innerStack: {
    // padding: '8px',
    // gap: '8px',
    // overflow: 'auto',
    // flex: 1,
    // maxHeight: 'calc(100svh - 300px)'
    },
    accordionHeader: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        // borderRadius: tokens.borderRadiusLarge,
        // backgroundColor: tokens.colorNeutralBackground1,
        // '& .fui-AccordionHeader__button': {
        //   borderRadius: tokens.borderRadiusLarge
        // }
    },
    accordionItem: { marginBottom: '12px' },
    questionItem: {
        marginBottom: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    headerText: {
        flexGrow: 1,
        paddingRight: '12px'
    },
    accordionPanel: {
        padding: '4px 8px',
        marginTop: '8px',
        // backgroundColor: tokens.colorNeutralBackground1,
        // margin: 0,
        // borderBottomLeftRadius: tokens.borderRadiusLarge,
        // borderBottomRightRadius: tokens.borderRadiusLarge,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        overflow: 'auto'
    },
    nestedAccordion: {
        padding: ' 8px 40px',
        display: 'flex',
        flexDirection: 'column'
    },
    nestedAccordionHeader: {
        borderLeft: '1px solid',
        '& .fui-AccordionHeader__button': {
        // borderRadius: tokens.borderRadiusLarge
        },
        // backgroundColor: tokens.colorNeutralBackground1Selected
    },
    nestedAccordionPanel: {
        cursor: 'pointer',
        padding: '8px 8px',
        marginTop: '8px',
        // backgroundColor: tokens.colorNeutralBackground1,
        // borderBottomLeftRadius: tokens.borderRadiusLarge,
        // borderBottomRightRadius: tokens.borderRadiusLarge
    },
    panelText: {
        cursor: 'pointer',
        padding: '4px 10px'
    },
    bottomButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)'
    },
    ChangeAnswerButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: '8px'
    },
    content: {
        paddingLeft: '12px'
    },
    tableOfContents: {}
};
